module.exports = __webpack_public_path__ + "static/pier-df94ced67720d4056b2046ef68bb48ad.jpg";